import { combineReducers } from 'redux';
import { loader } from './loader.reducer';
import { alertMess } from './alert.reducer';
import { locationsdata, menuid, menuitems, update, userstatus } from './user.reducer';
import { agentOptions } from './agent.reducer';

const rootReducer = combineReducers({
    loader, alertMess, userstatus, menuid, menuitems, locationsdata, update, agentOptions
})
export default rootReducer;